export enum ModuleName {
	CAD = 'CAD',
	CSG = 'CSG',
	GSAP = 'GSAP',
	PBR = 'PBR',
	POLY_ANIM = 'POLY_ANIM',
	POLY_GL = 'POLY_GL',
	POLY_JS = 'POLY_JS',
	POLY_OBJ = 'POLY_OBJ',
	POLY_SOP = 'POLY_SOP',
	QUAD = 'QUAD',
	SDF = 'SDF',
	TET = 'TET',
}
